import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword
} from "firebase/auth";
import {
  getFirestore,
  setDoc,
  doc
} from "firebase/firestore";

// 🔐 Firebase yapılandırman
const firebaseConfig = {
  apiKey: "AIzaSyDR2F3PakYJEJo9uqmO9cb367o6X19Epvc",
  authDomain: "aractakip-e606b.firebaseapp.com",
  projectId: "aractakip-e606b",
  storageBucket: "aractakip-e606b.appspot.com",
  messagingSenderId: "327024604844",
  appId: "1:327024604844:web:2cf233c4e8d508bbdf1109"
};

// 🔌 Uygulamayı başlat
const app = initializeApp(firebaseConfig);

// 🔐 Ana ve ikincil bağlantılar
export const auth = getAuth(app);
export const db = getFirestore(app);

// ✅ İkinci bağlantı ile kullanıcı oluşturma (admin'i çıkış yaptırmaz)
const secondaryApp = initializeApp(firebaseConfig, "Secondary");
const secondaryAuth = getAuth(secondaryApp);

export const createNewUser = async (email, password, role) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);

    await setDoc(doc(db, "users", email), {
      email,
      role,
      active: true
    });

    await secondaryAuth.signOut();
    return { success: true };
  } catch (error) {
    console.error("Yeni kullanıcı oluşturma hatası:", error.message);
    return { success: false, error: error.message };
  }
};

export const deactivateUser = async (email) => {
  try {
    await setDoc(doc(db, "users", email), { active: false }, { merge: true });
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
};
